import { actionsTypes } from '../constants/loadMenuDataConstants'

const INITIAL_STATE = {
  loading: false,
  error: false,
  data: null,
  storeCode: null
}

const reducers = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionsTypes.LOADING_DATA_REQUESTED:
      return {
        ...state,
        loading: true,
        storeCode: action.storeCode,
        error: false,
        data: null
      }
    case actionsTypes.LOADING_DATA_SUCCESS:
      return {
        ...state,
        data: action.data,
        loading: false,
        error: false
      }
    case actionsTypes.LOADING_DATA_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      }
    default:
      return {
        ...state
      }
  }
}

export { reducers }
